import { Routes } from "@angular/Router";
import { LoginComponent } from "./user/login/login.component";
import { RegisterComponent } from "./user/register/register.component";
import { HomeComponent } from "./home/home.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AuthGuard } from "./auth/auth.guard";
import { AdduserComponent } from "./sitemodules/vendors/adduser/adduser.component";
import { RoleguardServiceGuard } from "./auth/roleguard-service.guard";
import { SettingsComponent } from "./user/settings/settings.component";
import { ProfileComponent } from "./user/profile/profile.component";
import { SiteuserComponent } from "./sitemodules/siteuser/siteuserview/siteuser.component";
import { SiteusereditComponent } from "./sitemodules/siteuser/siteuseredit/siteuseredit.component";
import { SiteuseraddComponent } from "./sitemodules/siteuser/siteuseradd/siteuseradd.component";
import { ProductlistComponent } from "./sitemodules/products/productlist/productlist.component";
import { AddproductComponent } from "./sitemodules/products/addproduct/addproduct.component";
import { EditproductComponent } from "./sitemodules/products/editproduct/editproduct.component";
import { ViewproductComponent } from "./sitemodules/products/viewproduct/viewproduct.component";
import { CategorylistComponent } from "./sitemodules/productcategory/categorylist/categorylist.component";
import { AddcategoryComponent } from "./sitemodules/productcategory/addcategory/addcategory.component";
import { EditcategoryComponent } from "./sitemodules/productcategory/editcategory/editcategory.component";
import { OrderComponent } from "./sitemodules/orders/order/order.component";
import { CartitemsComponent } from "./sitemodules/orders/cartitems/cartitems.component";
import { ConfirmorderComponent } from "./sitemodules/orders/confirmorder/confirmorder.component";
import { MyordersComponent } from "./sitemodules/orders/myorders/myorders.component";
import { ManageordersComponent } from "./sitemodules/orders/manageorders/manageorders.component";
import { EditorderComponent } from "./sitemodules/orders/editorder/editorder.component";
import { EditorderitemsComponent } from "./sitemodules/orders/editorderitems/editorderitems.component";
import { AllordersComponent } from "./sitemodules/orders/allorders/allorders.component";
import { PortalsettingComponent } from "./sitemodules/portalsettings/portalsetting/portalsetting.component";
import { GeneratereportComponent } from "./sitemodules/reports/generatereport/generatereport.component";
import { EditsettingComponent } from "./sitemodules/portalsettings/editsetting/editsetting.component";
import { CancelorderComponent } from "./sitemodules/orders/cancelorder/cancelorder.component";
import { RepeatComponent } from "./sitemodules/orders/repeat/repeat.component";
import { CancelledordersComponent } from "./sitemodules/orders/vieworders/cancelledorders/cancelledorders.component";
import { FilledorderComponent } from "./sitemodules/orders/vieworders/filledorder/filledorder.component";
import { PendingordersComponent } from "./sitemodules/orders/vieworders/pendingorders/pendingorders.component";
import { HrorderuploadComponent } from "./sitemodules/reports/hrorderupload/hrorderupload.component";
import { FilledorderreportComponent } from "./sitemodules/reports/filledorderreport/filledorderreport.component";
import { ActiveuserComponent } from "./sitemodules/siteuser/userview/activeuser/activeuser.component";
import { InactiveuserComponent } from "./sitemodules/siteuser/userview/inactiveuser/inactiveuser.component";
import { EdituserComponent } from "./user/edituser/edituser.component";
import { ConfirmrepeatorderComponent } from "./sitemodules/orders/confirmrepeatorder/confirmrepeatorder.component";
import { ProductnewsComponent } from "./sitemodules/products/productnews/productnews.component";
import { ConfirmedscreenComponent } from "./sitemodules/orders/confirmedscreen/confirmedscreen.component";

export const appRoutes: Routes = [
    { path: 'home', component: HomeComponent },
    { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
    { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
    {
        path: 'register', component: RegisterComponent
    },
    {
        path: 'login', component: LoginComponent
    },
    { path: 'order', component:OrderComponent, canActivate: [AuthGuard] },
    { path: 'cartitems', component:CartitemsComponent, canActivate: [AuthGuard] },
    { path: 'confirmorder/:ordernumber', component:ConfirmorderComponent, canActivate: [AuthGuard] },
    { path: 'confirmrepeatorder/:ordernumber', component:ConfirmrepeatorderComponent, canActivate: [AuthGuard] },
    { path: 'myorders', component:MyordersComponent, canActivate: [AuthGuard] },
    { path: 'manageorder/:ordernumber', component:ManageordersComponent, canActivate: [AuthGuard] },
    { path: 'editorder/:ordernumber', component:EditorderComponent, canActivate: [AuthGuard] },
    { path: 'editorderitems/:ordernumber', component:EditorderitemsComponent, canActivate: [AuthGuard] },
    { path: 'allorders', component:AllordersComponent, canActivate: [AuthGuard] },
    { path: 'cancelorder/:ordernumber', component:CancelorderComponent, canActivate: [AuthGuard] },
    { path: 'repeatorder/:ordernumber', component:RepeatComponent, canActivate: [AuthGuard] },
    { path: 'cancelledorder', component:CancelledordersComponent, canActivate: [AuthGuard] },
    { path: 'filledorder', component:FilledorderComponent, canActivate: [AuthGuard] },
    { path: 'pendingorder', component:PendingordersComponent, canActivate: [AuthGuard] },
    { path: 'productnews', component: ProductnewsComponent, canActivate: [AuthGuard] },

    
    { 
        path: 'siteuser', 
        component: SiteuserComponent, 
        canActivate: [AuthGuard, RoleguardServiceGuard]
    },

    { path: 'addsiteuser', component: SiteuseraddComponent, canActivate: [AuthGuard] },
    {
        path: 'adduser',
        component: AdduserComponent,
        canActivate: [RoleguardServiceGuard],
        data: {
            expectedRole: 'admin'
        }
    },
    { 
        path: 'activeuser', 
        component: ActiveuserComponent, 
        canActivate: [AuthGuard, RoleguardServiceGuard]
    },
    { 
        path: 'disableduser', 
        component: InactiveuserComponent, 
        canActivate: [AuthGuard, RoleguardServiceGuard] 
    },


    { path: 'siteuseredit/:userid', component: SiteusereditComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'productlist', component:ProductlistComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'addproduct', component:AddproductComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'editproduct', component:EditproductComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'viewproduct', component:ViewproductComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'categorylist', component:CategorylistComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'addcategory', component:AddcategoryComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'editcategory', component:EditcategoryComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'portalsettings', component: PortalsettingComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'reports', component: GeneratereportComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'editsettings/:keyid', component:EditsettingComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'editcategory/:catid', component:EditcategoryComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'editproduct/:productid', component:EditproductComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'hrorderupload', component:HrorderuploadComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'filledorderreport', component:FilledorderreportComponent, canActivate: [AuthGuard, RoleguardServiceGuard] },
    { path: 'edituser/:userid', component: EdituserComponent, canActivate: [AuthGuard] },
    
    { path: 'orderconfirm/:ordernumber', component:ConfirmedscreenComponent, canActivate: [AuthGuard] },

    { path: '', redirectTo: '/home', pathMatch: 'full' }
];